import { QueryOperator } from '@moleculeone/types';
import { styled } from '../../../stitches.config';
import { Button, SimpleSelect } from '../..';

interface OperatorItem {
  value: QueryOperator;
  label: string;
}

interface OperatorProps {
  items: OperatorItem[];
  operator: QueryOperator;
  onChange: (value: QueryOperator) => void;
  onRemove?: () => unknown;
}

export const OperatorSidebar = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const OperatorContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '40px',
  minHeight: '184px',
  position: 'relative',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderRadius: '$medium',
});

const operatorSelectButtonCSS = {
  transform: 'rotate(-90deg)',
  boxSizing: 'content-box',
};

export function Operator(props: OperatorProps) {
  const { items, operator, onChange, onRemove } = props;

  return (
    <OperatorSidebar>
      <OperatorContainer>
        <SimpleSelect
          items={items}
          selectedItemValue={String(operator)}
          onChange={item => onChange(item.value)}
          placeholder="Operator"
          getItemValue={item => String(item.value)}
          getItemLabel={item => item.label}
          triggerProps={{
            css: operatorSelectButtonCSS,
            rightIcon: undefined,
            icon: 'chevron_left',
          }}
        />
        {onRemove && (
          <Button
            icon="delete"
            size="small"
            weight="minimal"
            onClick={onRemove}
            css={{
              position: 'absolute',
              bottom: 'calc((40px - 30px) / 2 - 2px)',
              margin: '0 auto',
              width: '30px',
            }}
          />
        )}
      </OperatorContainer>
    </OperatorSidebar>
  );
}
